/*
 * Hover-to-play product-card videos (collection grids, homepage featured
 * collections, search) — renders alongside snippets/product-grid-item-variant.liquid.
 *
 * - Desktop / hover-capable devices only. On touch / no-hover devices this script
 *   does nothing: the <video> is hidden by an INLINE style in the snippet (opacity:0),
 *   so it never shows and never downloads — the static poster behaves as before and a
 *   tap opens the product.
 * - Lazy: the markup uses <video preload="none">, so a card downloads ZERO video bytes
 *   until the first hover calls play(). Only one card plays at a time.
 * - Event delegation on document, so cards injected by AJAX (filters, pagination,
 *   infinite scroll) work without re-init.
 * - Hiding/showing is done by flipping the element's own inline opacity, so no theme
 *   stylesheet is touched and there is no flash of the video on first paint.
 */
(function () {
  // The <script> tag lives in the product-card snippet, so it can appear more than
  // once per page. Guard so listeners are only ever installed a single time.
  if (window.__cardVideoHoverInit) return;
  if (!window.matchMedia || !window.matchMedia('(hover: hover)').matches) return;
  window.__cardVideoHoverInit = true;

  var CARD = 'product-grid-item-variant';
  var VIDEO = 'video[data-card-video]';
  var current = null;

  function videoIn(card) { return card ? card.querySelector(VIDEO) : null; }

  function play(card) {
    var v = videoIn(card);
    if (!v) return;
    v.style.opacity = '1';
    var p = v.play();
    if (p && p.catch) p.catch(function () {});
  }

  function reset(card) {
    var v = videoIn(card);
    if (!v) return;
    v.style.opacity = '0';
    try { v.pause(); v.currentTime = 0; } catch (e) {}
  }

  document.addEventListener('mouseover', function (e) {
    var t = e.target;
    var card = t && t.closest ? t.closest(CARD) : null;
    if (card === current) return;
    if (current) reset(current);
    current = card;
    if (card) play(card);
  });

  document.addEventListener('mouseout', function (e) {
    if (!current) return;
    var to = e.relatedTarget;
    if (to && to.closest && to.closest(CARD) === current) return; // still within same card
    reset(current);
    current = null;
  });
})();
